import { Icon } from '@distribusion/owl-frontend-ui'
import React, { ReactElement } from 'react'

import { useTranslation } from '@lib/i18n'

interface LuggageProps {
  carrier: MarketingCarrier
}

const Luggage = ({ carrier }: LuggageProps): ReactElement => {
  const { t } = useTranslation()
  const { bigLuggageQuantity, bigLuggageSize, bigLuggageWeight } = carrier
  const { handLuggageQuantity, handLuggageSize, handLuggageWeight } = carrier

  const bigLuggage = !!bigLuggageQuantity && !!bigLuggageSize && !!bigLuggageWeight
  const handLuggage = !!handLuggageQuantity && !!handLuggageSize && !!handLuggageWeight

  return (
    <div className="trip-info__luggage row items-center">
      <Icon name="baggage" size="large" />
      <span className="trip-info__luggage-text">
        {bigLuggage &&
          t('checkout.tripDetails.bigLuggage', {
            count: Number(bigLuggageQuantity),
            weight: bigLuggageWeight,
            size: bigLuggageSize,
          })}
        {handLuggage && bigLuggage && ' + '}
        {handLuggage &&
          t('checkout.tripDetails.handLuggage', {
            count: Number(handLuggageQuantity),
            weight: handLuggageWeight,
            size: handLuggageSize,
          })}
      </span>
    </div>
  )
}

export default Luggage
